import React, { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';

// export type BaseDialogVariantsType = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '80vw' | 'screen';

interface BaseDialogProps {
  children?: ReactNode;
  content: ReactNode | string;
  title?: ReactNode | string;
  className?: string;
  onOpenChange?: (open: boolean) => void;
  open?: boolean;
}

export const BaseDialog = React.forwardRef<HTMLDivElement, BaseDialogProps>(
  ({ children, content, title, className, onOpenChange, open }, ref) => {
    if (!content) return <>{children}</>;

    const isReactElement = React.isValidElement(content);

    return (
      <Dialog onOpenChange={onOpenChange} open={open}>
        {children && <DialogTrigger asChild>{children}</DialogTrigger>}
        <DialogContent
          ref={ref}
          className={cn(`sm:mt-0 mt-[30px] max-w-4xl w-[90vw] h-[90vh], ${className}`)}
          onOpenAutoFocus={(e) => e.preventDefault()}
        >
          {title && (
            <DialogHeader>
              <DialogTitle>{title}</DialogTitle>
            </DialogHeader>
          )}
          {isReactElement ? (
            <div style={{ width: '100%', height: '100%', overflow: 'visible' }}>{content}</div>
          ) : (
            <DialogDescription>{content}</DialogDescription>
          )}
        </DialogContent>
      </Dialog>
    );
  }
);

BaseDialog.displayName = 'BaseDialog';
